import React, {useEffect, useState} from 'react';
import './App.css';
import Main from "./components/Main";
import MenuModalRoot from "./components/modals/MenuModalRoot";
import AGModalRoot from "./components/modals/AGModalRoot";
import "./i18n";
import {apiService} from "./services/api.service";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {AGModalId, AGModalOpen} from "./store/slices/main.slice";
import {useDispatch} from "react-redux";

function App() {
    const { i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(true)
    const navigate = useNavigate();
    const dispatch: any = useDispatch();

    useEffect(() => {
        apiService.getTranslations(i18n.language)
            .then((res) => {
                i18n.addResourceBundle(
                    i18n.language,
                    "translation",
                    res.data
                );

                if(res.status === 200) {
                    setIsLoading(false)
                }

            })
    }, [i18n.language]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const idParam = params.get('id');
        if (!idParam) return;

        navigate(`/`)
        dispatch(AGModalOpen(true))
        dispatch(AGModalId(idParam));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // solo al mount


    if(isLoading) {
        return null
    }

    return (
        <div>
            <AGModalRoot/>
            <MenuModalRoot/>
            <Main/>
        </div>
    );
}

export default App;
